<div class="main-input-form">
    <form #myForm="ngForm" (ngSubmit)="save()">
      <div class="input-wrapper">
          <div class="side-wrapper edit-form-title-wrapper">
              <div class="user-icon"></div>
              <p class="input-form-title">Add/Edit Form action</p>
          </div>
  
          <div class="menu-input-wrapper">
              <div class="tab-menu">
                  <div class="tab basic-info" (click)="setActiveTab('basic-info')" [ngClass]="{'active': activetab=='basic-info'}">
                      <p>{{'HOME.ROLES_BASICINFO_TABTITLE' | translate}}</p>
                  </div> 
              </div>
              <!--
              -->
              <div class="input-content">
                  <div class="basic-info" *ngIf="activetab == 'basic-info'">
  
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_BASICINFO_GENERAL' | translate}}</p>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                            <div class="input-control">
                                <div class="title"><label for="Title">{{'FORM_ACTION.TITLE' | translate}}</label></div>
                                <input class="form-control" type="text" name="Title" [(ngModel)]="model.Title" />
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="Name">{{'FORM_ACTION.NAME' | translate}}</label></div>
                                <input class="form-control" type="text" name="Name" [(ngModel)]="model.Name" />
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="ActionName">{{'FORM_ACTION.ACTION_NAME' | translate}}</label></div>
                                <input class="form-control" type="text" name="ActionName" [(ngModel)]="model.ActionName" />
                            </div>        
                            <div class="input-control">
                                <div class="title"><label for="Target">{{'FORM_ACTION.TARGET' | translate}}</label></div>
                                <input class="form-control" type="text" name="Target" [(ngModel)]="model.Target" />
                            </div>                     

                            <div class="input-control">
                                <div class="title"><label for="DynamicFormId">{{'FORM_ACTION.DYNAMIC_FORM' | translate}}</label></div>
                                <input class="form-control" type="text" name="DynamicFormId" [(ngModel)]="model.DynamicFormId" />
                            </div>                         

                            <div class="input-control">
                                <div class="title"><label for="PreJS">{{'FORM_ACTION.PRE_JS' | translate}}</label></div>
                                <textarea rows="10" class="form-control" type="text" name="PreJS" [(ngModel)]="model.PreJS"></textarea>
                            </div>                     
                            <div class="input-control">
                                <div class="title"><label for="PostJS">{{'FORM_ACTION.POST_JS' | translate}}</label></div>
                                <textarea rows="10" class="form-control" type="text" name="PostJS" [(ngModel)]="model.PostJS"></textarea>
                            </div>                     
                            <div class="input-control">
                                <div class="title"><label for="Type">{{'FORM_ACTION.TYPE' | translate}}</label></div>
                                <select class="form-control"  name="Type"  [(ngModel)]="model.Type">
                                    <option value="1">Action = 1</option>
                                    <option value="2">Workflow = 2</option>
                                    <option value="3">FileDataAction = 3</option>
                                </select>
                            </div>      
                            <div class="input-control">
                                <div class="title"><label for="Parameters">{{'FORM_ACTION.PARAMETERS' | translate}}</label></div>
                                <textarea rows="10" class="form-control" type="text" name="Parameters" [(ngModel)]="model.Parameters"></textarea>
                            </div>       

                            <div class="input-control">
                                <div class="title"><label for="ParameterFormId">{{'FORM_ACTION.PARAMETER_FORM' | translate}}</label></div>
                                <input class="form-control" type="text" name="ParameterFormId" [(ngModel)]="model.ParameterFormId" />
                            </div>                                      

                            <div class="input-control">
                                <div class="title"><label for="Projection">{{'FORM_ACTION.PROJECTION' | translate}}</label></div>
                                <textarea rows="10" class="form-control" type="text" name="Projection" [(ngModel)]="model.Projection"></textarea>
                            </div>        

                            <div class="input-control">
                                <div class="title"><label for="ProjectionDynamicFormId">{{'FORM_ACTION.PROJECTION_FORM' | translate}}</label></div>
                                <input class="form-control" type="text" name="ProjectionDynamicFormId" [(ngModel)]="model.ProjectionDynamicFormId" />
                            </div>                                           
                            <div class="input-control">
                                <div class="title"><label for="Projection">{{'FORM_ACTION.ONLY_CLIENT_LOGIC' | translate}}</label></div>
                                <input type="checkbox" name="OnlyClientLogic" [(ngModel)]="model.OnlyClientLogic" />
                            </div>   
                            <div class="input-control">
                                <div class="title"><label for="Projection">{{'FORM_ACTION.SKIP_BLUK_ACTION_API_METHOD' | translate}}</label></div>
                                <input type="checkbox" name="OnlyClientLogic" [(ngModel)]="model.SkipBulkActionApiMethod" />
                            </div>                                                                                                                                                            

                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
                              </div>
                          </div>
                      </div>
                  </div>    
              </div>
          </div>
  
      </div>
  </form>
  </div>